import { postAuth } from "utils/api";

export const forgetPassword = async (params) => {
  return await postAuth("/forget-password", {
    ...params,
  });
};
